module.exports = __webpack_public_path__ + "static/subset-UniNeueBold-434dbf9f8b7bc996b3c2051bfd2cb14f.woff2";